import { EnvTypes } from './base-url-util';

export const isDevMode = () => (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

export const isProdEnv = () => process.env.REACT_APP_STAGE === EnvTypes.PROD;

export const getEnvironment = () => process.env.REACT_APP_STAGE;
